export const TAXI_TYPE = {
  UBER: 'UBER',
  CLASSIC: 'CLASSIC',
};

export const TRIP_PAYMENT_METHOD = {
  CREDIT_CARD: '信用卡',
  CASH: '現金',
};
